export const keyPermissionOptions = [
  { value: true, label: 'Allowed' },
  { value: false, label: 'Not allowed' },
];
